import { ComponentProps } from "react";

const PlusFillIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* Filled blue circle */}
      <circle cx="12" cy="13.5" r="11" fill="rgb(31 132 117 / 1)" />
      {/* White plus icon */}{" "}
      <path
        d="M17 12.8099H13V8.46511C13 8.17703 12.8946 7.90075 12.7071 7.69705C12.5196 7.49335 12.2652 7.37891 12 7.37891C11.7348 7.37891 11.4804 7.49335 11.2929 7.69705C11.1054 7.90075 11 8.17703 11 8.46511V12.8099H7C6.73478 12.8099 6.48043 12.9244 6.29289 13.1281C6.10536 13.3318 6 13.6081 6 13.8961C6 14.1842 6.10536 14.4605 6.29289 14.6642C6.48043 14.8679 6.73478 14.9824 7 14.9824H11V19.3272C11 19.6153 11.1054 19.8915 11.2929 20.0952C11.4804 20.2989 11.7348 20.4134 12 20.4134C12.2652 20.4134 12.5196 20.2989 12.7071 20.0952C12.8946 19.8915 13 19.6153 13 19.3272V14.9824H17C17.2652 14.9824 17.5196 14.8679 17.7071 14.6642C17.8946 14.4605 18 14.1842 18 13.8961C18 13.6081 17.8946 13.3318 17.7071 13.1281C17.5196 12.9244 17.2652 12.8099 17 12.8099Z"
        fill="white"
      />{" "}
    </svg>
  );
};

export default PlusFillIcon;
